<div class="breadcrumb-main">
  <div class="labl-page" *ngIf="lablPage">
    <h2>{{lablPage |translate}}</h2>
  </div>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <!-- <li class="breadcrumb-item"><a href="javascript:void(0)">{{breadcrumbItem}}</a></li>
      <li>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9">
            <path id="angle-right"
              d="M13.642,10.647,10.249,7.008a.763.763,0,0,0-1.137,0,.9.9,0,0,0,0,1.21l2.834,3.038L9.112,14.3a.9.9,0,0,0,0,1.21.773.773,0,0,0,1.137,0l3.394-3.639a.9.9,0,0,0,0-1.219Z"
              transform="translate(-8.879 -6.754)" fill="#888f9e" />
          </svg>

        </div>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{breadcrumbItemActive}}</li> -->
      <ng-container *ngFor="let item of breadcrumbItemsList; let i=index">
        <li class="breadcrumb-item" [class.active]="i==breadcrumbItemsList.length-1">
          <a (click)="_config.goTo(item.url)">{{item.title |translate}}</a>
        </li>
        <li *ngIf="i<breadcrumbItemsList.length-1">
          <div class="breadcrumb_indecator">
            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9">
              <path id="angle-right"
                d="M13.642,10.647,10.249,7.008a.763.763,0,0,0-1.137,0,.9.9,0,0,0,0,1.21l2.834,3.038L9.112,14.3a.9.9,0,0,0,0,1.21.773.773,0,0,0,1.137,0l3.394-3.639a.9.9,0,0,0,0-1.219Z"
                transform="translate(-8.879 -6.754)" fill="#888f9e" />
            </svg>
          </div>
        </li>
      </ng-container>


    </ol>
  </nav>
</div>
<!-- <app-auction-end-count-down [TotalTime]="120" [RemainingTime]="10" TimerMode="minute"></app-auction-end-count-down> -->